//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PasswordDetails from "./reset-password/password-details.vue";
import PasswordSet from "./reset-password/password-set.vue";
import PasswordVerify from "./reset-password/password-verify.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ResetPasswordContainer",
  components: {
    PasswordDetails,
    PasswordVerify,
    PasswordSet
  },
  data() {
    return {
      currentPage: "password-details",
      emailReset: ""
    };
  },
  computed: {
    page() {
      const componentMap = {
        "password-details": PasswordDetails,
        "password-verify": PasswordVerify,
        "password-set": PasswordSet
      };
      return componentMap[this.currentPage];
    }
  },
  methods: {
    handleNextPage({
      page,
      email
    }) {
      this.currentPage = page;
      if (email) this.emailReset = email;
    }
  }
});